import React from 'react'
import useFetch from '../../hooks/useFetch'
import { baseURL1 } from '../../utils/baseUrl'
import strings from '../../utils/locals/languages'

const Partners = () => {

    const { data } = useFetch(`${baseURL1}/v1/user/view-partners?location=homePage`)

    return (
        <>
            {
                data && data.partners.length !== 0 && (
                    <div className="container ">
                        <h5 className="p-0 m-0 font-semibold text-[20px]">{strings.ourP}</h5>
                        <div className="flex justify-center overflow-x-auto gap-4 mt-4 px-2">
                            {
                                data && data.partners?.map((item, index) => (
                                    <div
                                        className="flex-shrink-0 rounded flex items-center"
                                        key={index}
                                        style={{ width: "80px", height: "80px" }}
                                    >
                                        <img
                                            className="w-full h-full object-contain"
                                            src={item.imageUrl}
                                            alt={`Partner ${index}`}
                                        />
                                    </div>
                                ))
                            }
                        </div>


                    </div>
                )
            }
        </>
    )
}

export default Partners